import Tooltip from "@mui/material/Tooltip";
import { READ_ONLY_MESSAGE, useViewAs } from "../../viewAs";

/**
 * Says why a control is disabled while viewing as another user. A disabled
 * button fires no mouse events, so the tooltip hangs off a wrapping span. Off
 * view-as, or when `when` is false, the child renders untouched.
 *
 * The control still needs its own `disabled={readOnly || ...}`; this only
 * explains it.
 */
const ReadOnlyTooltip = ({ children, block = false, when = true }) => {
  const { readOnly } = useViewAs();
  if (!readOnly || !when) return children;

  return (
    <Tooltip title={READ_ONLY_MESSAGE} arrow>
      <span style={{ display: block ? "block" : "inline-block" }}>
        {children}
      </span>
    </Tooltip>
  );
};

export default ReadOnlyTooltip;
